import React from "react";

// Motion-free, minimal Card used across the app
export default function Card({ title, action, children, className = "" }) {
  return (
    <section className={`rounded-xl border border-line bg-white shadow-sm ${className}`}>
      {(title || action) && (
        <header className="flex items-center justify-between gap-3 px-4 md:px-5 py-3 border-b border-gray-100">
          <h3 className="text-[15px] font-semibold text-ink">{title}</h3>
          {action}
        </header>
      )}
      <div className="p-4 md:p-5">{children}</div>
    </section>
  );
}
